import AppDispatcher from "../../../flux/dispatcher/dispatcher";
import Constant from "../constant/Constant";
import LogoutConstant from "../../MainFrame/constants/Constants";
import restClient from "../../MainFrame/action/APIClient";

var DeleteNavigationItemAction = function () {};

DeleteNavigationItemAction.prototype = {
    deleteNavigation: function (data) {
        restClient.deleteNavigation(data, function (error, response) {
            if (error) {
                if (error.status === 401) {
                    AppDispatcher.dispatch({
                        actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
                        data: error,
                    });
                } else {
                    AppDispatcher.dispatch({
                        actionType: Constant.DELETE_NAVIGATION,
                        data: error,
                    });
                }
            } else {
                response['status'] = 200;
                AppDispatcher.dispatch({
                    actionType: Constant.DELETE_NAVIGATION,
                    data: response,
                });
            }
        });
    },
};

export default new DeleteNavigationItemAction();
